import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";

const features = [
    {
        title: "Mobile-First Design",
        description: "Prioritize the mobile user experience by designing for small screens first.",
        imgUrl: "./img/services/responsive-website/mobile-first-design.png",
    },
    {
        title: "Flexible Grids",
        description: "Use fluid grid layouts to adapt content seamlessly across different screen sizes.",
        imgUrl: "./img/services/responsive-website/flexible-grids.jpg",
    },
    {
        title: "Responsive Images",
        description: "Ensure images scale properly to avoid breaking layouts on various devices.",
        imgUrl: "./img/services/responsive-website/responsive-images.jpg",
    },
    {
        title: "Media Queries",
        description: "Leverage CSS media queries to apply styles based on device characteristics.",
        imgUrl: "./img/services/responsive-website/media-queries.jpg",
    },
    {
        title: "Cross-Browser Compatibility",
        description: "Test and optimize your website for all modern browsers.",
        imgUrl: "./img/services/responsive-website/cross-browser-compatibility.jpg",
    },
    {
        title: "Performance Optimization",
        description: "Minimize load times with optimized assets and efficient code.",
        imgUrl: "./img/services/responsive-website/perfomance-optimization.png",
    },
];

const ResponsiveWebsites = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "Responsive Websites", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="Responsive Websites" description="Design and develop websites that look great and function seamlessly on any device." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is a Responsive Website?</h2>
                            <p>
                                A responsive website automatically adjusts its layout and content based on the screen size and orientation, providing an optimal user experience on any device, whether it's a smartphone, tablet, or desktop.
                            </p>
                            <img
                                src="./img/services/responsive-website.jpg"
                                alt="Responsive Website Overview"
                                className="about-image"
                            />
                        </section>

                        <section className="services">
                            <h2>Key Features of Responsive Design</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>

                        <section className="benefits">
                            <h2>Why Choose Responsive Design?</h2>
                            <ul>
                                <li> Improved user experience across devices </li>
                                <li>Better SEO rankings with mobile-friendly designs</li>
                                <li>Cost-effective single design for all platforms</li>
                                <li>Future-proof websites for emerging technologies</li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Ready to Go Responsive?</h2>
                            <p>
                                Let us help you build a responsive website that works seamlessly on all devices. <br /> Contact us at <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default ResponsiveWebsites;
